import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';


export default StyleSheet.create({
  barChart: {
    paddingHorizontal: 60,
  },
  mainWrapper:{
    // flex:1,
  },
  root:{
    flex: 1,
    backgroundColor: '#12213c',
    paddingBottom: 10,
  },
  lineChartWrapper:{
   position:'absolute',
  },
  notice:{
    flex: 1,
    alignItems: 'center',
    paddingVertical: 20
  },
  monthlyText:{
    color:'#0098dc'
  },
  cumulativeText:{
    color: PALETTE.primaryActive,
    marginLeft: 20,
  },
  infoWrapper:{
    marginLeft:20,
    flex:1,
    flexDirection:'row',
  },
  alignCenter:{
    flex:1,
    flexDirection:'row',
    alignItems: 'center',
    justifyContent:'center',
  },
  cardContainer: {
    margin: 30,
  },
  cardHeaderView: {
    width: '100%',
  },
  cardBodyView: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  cardBodyVerticalSeparator: {
    borderLeftWidth: 1,
    borderColor: PALETTE.primaryText,
    marginLeft: 15,
    marginRight: 15,
    width: 1
  },
});
